/**
 * this function returns the width and height of the logo based on the size prop
 */
export const getAspectRatio = (size: number, aspectRatio: number) => ({
  width: size,
  height: size / aspectRatio,
});
